import { api } from "./client";

export type Role = "admin" | "user";

export interface MeResponse {
  user_id: number;
  username: string;
  role: Role;
  active_vps_id: number | null;
  expires_at_unix: number;
}

export interface LoginResponse {
  user_id: number;
  username: string;
  role: Role;
  expires_at: string;
}

export const auth = {
  me: () => api<MeResponse>("/api/auth/me"),
  login: (username: string, password: string) =>
    api<LoginResponse>("/api/auth/login", {
      method: "POST",
      body: { username, password },
    }),
  logout: () => api<{ ok: boolean }>("/api/auth/logout", { method: "POST" }),
  enterVps: (vpsId: number) =>
    api<{ active_vps_id: number }>(`/api/auth/enter/${vpsId}`, { method: "POST" }),
  changeMyPassword: (current_password: string, new_password: string) =>
    api<{ ok: boolean }>("/api/me/password", {
      method: "POST",
      body: { current_password, new_password },
    }),
};
